import styled from "styled-components/macro";

// Shared styled primitives for the citation editors (create + edit paths) so the
// two tabs render identically. Behavioral logic stays in the components.

// Wrapper around the citations DataTable; matches the row-hover treatment used by
// the policy-list widget.
export const TableWrap = styled.div`
  margin-bottom: 1rem;

  tbody tr:hover td {
    background: #eff6ff;
  }
`;

// Two stacked inputs shown in a Citation cell while a row is being edited, so a
// long label never widens the cell past the fixed Actions column.
export const EditFields = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

// Save/Cancel (or Create/Cancel) shown in the Actions cell while a row is being edited.
export const ActionButtons = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
`;

// Muted label shown in place of row actions for read-only (ACES managed) rows.
export const ReadOnlyTag = styled.span`
  font-size: 0.75rem;
  color: #888;
  white-space: nowrap;
`;

// Styled anchor so a clicked citation doesn't keep the browser-default :visited
// color. Matches the app's other links by pinning every state to the theme color.
export const CitationAnchor = styled.a`
  text-decoration: none;
  color: ${(props) => props.theme.linkPrimary};
  &:visited,
  &:active {
    color: ${(props) => props.theme.linkPrimary};
  }
  &:hover {
    text-decoration: underline;
  }
  word-break: break-word;
  overflow-wrap: anywhere;
`;
